import React, { memo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import AutoSizer from "react-virtualized-auto-sizer";
import { Scrollbars } from "react-custom-scrollbars";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { HighlightSpan } from './PriceBoardTotalMode';
import IndustryValueScaleSumaryStackChart from './industry-components/IndustryValueScaleSumaryStackChart';

import { constTypeIndex } from '../helpers/constData';
import { priceToNumber, formatNumber, formatNumberToB, formatNumberToB_N1 } from '../helpers/utils';
import { showPopupInfo } from '../redux/actions/sharedActions';

const boxMinWidth = 260;

export default function Statistic() {

    const [displayMode, setDisplayMode] = useState('');
    const [sortConfig, setSortConfig] = useState({ column: 'industryName', type: 'asc', dataType: 'text' });
    const _fireEvent = true;

    const dispatch = useDispatch();
    const { t } = useTranslation();

    //
    const language = useSelector(state => state.gShared.language);

    const { industries } = useSelector(state => ({
        industries: state.gShared.industries,
        industriesLength: state.gShared.industries?.length ?? 0,
    }), (prev, next) => {
        return prev.industriesLength === next.industriesLength;
    })

    const { industryIndeses } = useSelector(state => ({
        industryIndeses: state.gIndex.indexInfos.filter((e) => e.typeIndex == constTypeIndex.Group),
        industryIndesesCounter: state.gIndex.indexInfos.filter((e) => e.typeIndex == constTypeIndex.Group)?.reduce(function (prevValue, currValue) {
            return prevValue + currValue.counter;
        }, 0) ?? 0,
    }), (prev, next) => {
        return prev.industryIndesesCounter === next.industryIndesesCounter;
    })

    //
    const _handleClickSort = (newColumn, newDataType) => {
        try {
            const { column, type } = sortConfig;
            let newType = 'asc';
            //
            if (column === newColumn) {
                if (type === 'asc') {
                    newType = 'desc';
                }
            }
            //
            setSortConfig({
                column: newColumn,
                type: newType,
                dataType: newDataType
            });
        } catch (error) {
        }
    }

    const _getDatas = () => {
        try {
            if (industryIndeses === undefined || industryIndeses === null) {
                return industryIndeses;
            }

            let _datas = industryIndeses.map((item, idx) => {
                const _industryInfo = industries.find(e => e.code === item.indexCode);
                // const _industryName = language === "en" ? (_industryInfo && _industryInfo.nameEn !== "" ? _industryInfo.nameEn : _industryInfo.name) : _industryInfo.name;
                const _industryName = t("codeIndustry_" + _industryInfo.code)
                item.industryName = _industryName ?? item.indexName;
                return item;
            });

            // Sort
            const { column, type, dataType } = sortConfig;
            let trueValue = -1;
            let falseValue = 1;

            if (type && type === 'desc') {
                trueValue = 1;
                falseValue = -1;
            }

            if (dataType && dataType === 'number') {
                _datas = _datas.sort((a, b) => Number(a[column] ?? 0) < Number(b[column] ?? 0) ? trueValue : falseValue);
            }
            else {
                _datas = _datas.sort((a, b) => a[column].localeCompare(b[column]) < 0 ? trueValue : a[column].localeCompare(b[column]) > 0 ? falseValue : 0);
            }

            return _datas;
        } catch (error) {
        }
    }

    //
    const _industryIndeses = _getDatas();

    //
    return (
        <div className="d-flex flex-column h-100 block__branch">
            <div className="block__branch--title">
                <h3>{t("thongKeNganh")}</h3>
                <div className="btndisplay">
                    <div title={t('chiTiet')} className={displayMode === '' || displayMode === 'DETAIL' ? 'active' : ''} onClick={() => setDisplayMode('DETAIL')}>
                        <img src="/static/img/icon/icon-list-table.svg" alt="img" />
                    </div>
                    <div title={t('Thumbnail')} className={displayMode && displayMode === 'BOX' ? 'active' : ''} onClick={() => setDisplayMode('BOX')}>
                        <img src="/static/img/icon/icon-grid.svg" alt="img" />
                    </div>
                </div>
            </div>
            <div className="block__branch--tbl" style={{ flex: 1 }}>
                <AutoSizer>
                    {({ height, width }) => {
                        const numberCol = Math.floor((width - 10) / boxMinWidth);

                        return (
                            <div style={{ height: height, width: width }}>
                                {displayMode && displayMode === 'BOX' ? (
                                    <Scrollbars
                                        autoHide={true}
                                        autoHeight={true}
                                        autoHeightMax={height}
                                        style={{ width: width }}
                                        renderTrackHorizontal={props => <div {...props} className="scroll-track-horizontal" />}
                                        renderTrackVertical={props => <div {...props} className="scroll-track-vertical" />}
                                        renderThumbHorizontal={props => <div {...props} className="scroll-thumb-horizontal" />}
                                        renderThumbVertical={props => <div {...props} className="scroll-thumb-vertical" />}
                                        renderView={props => <div {...props} className="scroll-view" />}
                                        className={"scroll-container"}
                                    >
                                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(' + numberCol + ', 1fr)', padding: 5, columnGap: 5, rowGap: 5 }}>
                                            {_industryIndeses && _industryIndeses.map((item, index) => {
                                                const _priceRatioChange = priceToNumber(item.priceRatioChange);
                                                const _colorClass = _priceRatioChange > 0 ? "bg-up-dark" : (_priceRatioChange < 0 ? "bg-down-dark" : "bg-ref-dark");

                                                return (
                                                    <div key={index} className={clsx('', _colorClass)} style={{ padding: 20, borderRadius: 5 }}
                                                        onClick={() => { showPopupInfo(dispatch, "IND", item.indexCode); }}>
                                                        <div className='d-flex flex-column h-100' style={{ justifyContent: 'flex-end', alignItems: 'center', gap: 5, fontSize: '1.15rem' }}>
                                                            <p className='text-center' style={{ fontWeight: 'bolder', textTransform: 'uppercase' }}>{item.industryName}</p>
                                                            <p style={{ fontSize: '2.5rem', padding: '5px 0' }}>{item.priceRatioChange}%</p>
                                                            <div className='d-flex w-100'>
                                                                <div className='nowrap'>{t('klgd')}:</div>
                                                                <div className='text-right' style={{ flex: 1 }}>{formatNumber(item.totalTradedQtty)}</div>
                                                            </div>
                                                            <div className='d-flex w-100'>
                                                                <div className='nowrap'>{t('gtgd')} ({t('ty')}):</div>
                                                                <div className='text-right' style={{ flex: 1 }}>{formatNumberToB(item.totalTradedValue)}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <div style={{ paddingTop: 10 }}>
                                            <IndustryValueScaleSumaryStackChart industryIndeses={_industryIndeses} style={{ height: 250 }} />
                                        </div>
                                    </Scrollbars>
                                ) : (
                                    <div className='scroll-styled'>
                                        <table className="tb-sticky sticky-left">
                                            <thead>
                                                <tr>
                                                    <th className={clsx("text-left th-sort", (sortConfig.column === 'industryName' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('industryName', 'text')}>{t("tenNganh")}</th>
                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'totalStock' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('totalStock', 'number')}>{t("soCK")}</th>
                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'up' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('up', 'number')}>{t("soCKTang")}</th>
                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'down' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('down', 'number')}>{t("soCKGiam")}</th>
                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'noChange' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('noChange', 'number')}>{t("soCKDungGia")}</th>

                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'priceRatioChange' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('priceRatioChange', 'number')}>{t("tyLeThayDoiGia")}</th>

                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'totalTradedQtty' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('totalTradedQtty', 'number')}>{t("klgd")}</th>
                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'totalTradedValue' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('totalTradedValue', 'number')}>{t("gtgd")}</th>
                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'buyForeignValue' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('buyForeignValue', 'number')}>{t("gtNNMua")}</th>
                                                    <th className={clsx("text-right th-sort", (sortConfig.column === 'sellForeignValue' ? 'th-sort-' + sortConfig.type : ''))} onClick={() => _handleClickSort('sellForeignValue', 'number')}>{t("gtNNBan")}</th>
                                                    <th className={"text-right"}>{t("phanBoDongTien")}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {_industryIndeses && _industryIndeses.map((item, index) => {
                                                    const _priceRatioChange = priceToNumber(item.priceRatioChange);
                                                    const _colorClass = _priceRatioChange > 0 ? "clr-up" : (_priceRatioChange < 0 ? "clr-down" : "clr-ref");

                                                    return (
                                                        <tr key={index}>
                                                            {/* <td onClick={() => { showPopupInfo(dispatch, "IND", item.indexCode); }}>{item.industryName}</td> */}
                                                            <td onClick={() => { showPopupInfo(dispatch, "IND", item.indexCode); }}>{t("codeIndustry_" + item.indexCode)}</td>
                                                            <td className={"text-right"}><HighlightSpan id={item.indexCode + "_s_totalStock"} value={item.totalStock} fireEvent={_fireEvent} /></td>
                                                            <td className={"text-right clr-up"}><HighlightSpan id={item.indexCode + "_s_up"} value={item.up} fireEvent={_fireEvent} /></td>
                                                            <td className={"text-right clr-down"}><HighlightSpan id={item.indexCode + "_s_down"} value={item.down} fireEvent={_fireEvent} /></td>
                                                            <td className={"text-right clr-ref"}><HighlightSpan id={item.indexCode + "_s_noChange"} value={item.noChange} fireEvent={_fireEvent} /></td>

                                                            <td className={clsx("text-right", _colorClass)}><HighlightSpan id={item.indexCode + "_s_priceRatioChange"} value={item.priceRatioChange} fireEvent={_fireEvent} /></td>

                                                            <td className={"text-right"}><HighlightSpan id={item.indexCode + "_s_totalTradedQtty"} value={formatNumber(item.totalTradedQtty)} fireEvent={_fireEvent} /></td>
                                                            <td className={"text-right"}><HighlightSpan id={item.indexCode + "_s_totalTradedValue"} value={formatNumber(item.totalTradedValue)} fireEvent={_fireEvent} /></td>
                                                            <td className={"text-right"}><HighlightSpan id={item.indexCode + "_s_buyForeignValue"} value={formatNumber(item.buyForeignValue)} fireEvent={_fireEvent} /></td>
                                                            <td className={"text-right"}><HighlightSpan id={item.indexCode + "_s_sellForeignValue"} value={formatNumber(item.sellForeignValue)} fireEvent={_fireEvent} /></td>
                                                            <td><StackDongTien totalTradedValueUp={item.totalTradedValueUp} totalTradedValueDown={item.totalTradedValueDown} totalTradedValueNoChange={item.totalTradedValueNoChange} /></td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )
                    }}
                </AutoSizer>
            </div>
        </div>

    )
}

const StackDongTien = memo(function (props) {
    const { totalTradedValueUp, totalTradedValueDown, totalTradedValueNoChange } = props;

    const { t } = useTranslation();

    const _totalTradedValueUp = priceToNumber(totalTradedValueUp);
    const _totalTradedValueDown = priceToNumber(totalTradedValueDown);
    const _totalTradedValueNoChange = priceToNumber(totalTradedValueNoChange);
    const _total = _totalTradedValueUp + _totalTradedValueDown + _totalTradedValueNoChange;

    let _upWidth = 33.333, _downWidth = 33.333, _noChangeWidth = 33.333;
    if (_total != 0) {
        _upWidth = (_totalTradedValueUp / _total * 100);
        _downWidth = (_totalTradedValueDown / _total * 100);
        _noChangeWidth = (_totalTradedValueNoChange / _total * 100);
    }
    //
    return (
        <OverlayTrigger placement='left' overlay={
            <Tooltip style={{ opacity: 1 }}>
                <div className='tooltip-grid'>
                    <span className='text-left'>{t("tang")}</span><span className='text-right clr-up'>{formatNumberToB_N1(totalTradedValueUp)} {t('ty')}</span>
                    <span className='text-left'>{t("khongDoi")}</span><span className='text-right clr-ref'>{formatNumberToB_N1(totalTradedValueNoChange)} {t('ty')}</span>
                    <span className='text-left'>{t("giam")}</span><span className='text-right clr-down'>{formatNumberToB_N1(totalTradedValueDown)} {t('ty')}</span>
                </div>
            </Tooltip>
        }>
            <div style={{ display: 'flex', width: '100%', height: '12px', borderRadius: '1px', overflow: 'hidden' }}>
                <div style={{ padding: 0, width: _upWidth + '%' }} className="bg-up"></div>
                <div style={{ padding: 0, width: _noChangeWidth + '%' }} className="bg-ref"></div>
                <div style={{ padding: 0, width: _downWidth + '%' }} className="bg-down"></div>
            </div>
        </OverlayTrigger>
    )
})